// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-wrapper {
  display: flex;
  box-sizing: border-box;
  padding-top: 64px;
  height: 100vh;
  background-color: var(--background-color); /* Dark background */
  color: var(--text-color); /* Text color */
  font-family: "Montserrat", sans-serif; 
}

.admin-main {
  padding: 20px;
  width: 90%;
  margin: 0 auto;
}

.admin-header {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  font-family: 'Eastlane Medium', sans-serif;
}

.user-count {
  margin-top: 10px;
  font-size: 16px;
  color: var(--secondary-text-color);
  font-weight: 600;
}

.search-input {
  padding: 10px;
  border: 1px solid var(--secondary-text-color);
  border-radius: 4px;
  margin-top: 10px;
  background: var(--secondary-background-color);
}

.user-table {
  background-color: var(--secondary-background-color);
  border-radius: 2px;
  overflow: hidden;
}

.table-header {
  display: flex;
  font-weight: bold;
  padding-left: 10px;
}

.table-header .table-cell {
  text-align: left;
  font-weight: 800;
  /* padding-left: 25px; */
}

.table-row {
  display: flex;
  align-items: center; /* Center items vertically */
  padding: 10px 15px; /* Set consistent padding for rows */
  transition: background 0.3s; /* Smooth background change */
}

.table-row:hover {
  background-color: var(--secondary-color); /* Change color on row hover */
}

.table-cell {
  padding: 10px; /* Ensure consistent padding for cells */
  flex: 1 1;
  text-align: left;
  border-bottom: 1px solid var(--secondary-color); /* Row separator */
  height: 50px; /* Set a fixed height if necessary */
  align-content: center;
  font-weight: 500;
}

.user-info {
  display: flex;
  align-items: center; /* Center items vertically */
}

.user-picture {
  margin-right: 10px;
  font-size: 20px;
}

.user-name {
  font-weight: bold; /* Make name bold */
}

.user-email {
  font-size: 12px; /* Smaller font size for email */
  color: var(--secondary-text-color); /* Grey color for email */
}

.actions {
  display: flex;
  justify-content: flex-end;
}

.action-button {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--secondary-text-color); /* Color for action icons */
  margin-left: 10px;
}

.action-button:hover {
  color: var(--text-color); /* Change color on hover */
}

.nav-item {
  padding: 15px;
  font-size: 1.1rem;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
  border-radius: 8px;
}

.navbar-admin-wrapper {
  font-family: "Eastlane Medium", "Montserrat", sans-serif; 
}

.navbar-admin-wrapper li a {
  font-family: "Eastlane Medium", "Montserrat", sans-serif; 
}

.navbar-admin-wrapper li a:hover {
  color: var(--highlight-color)!important; /* Adjust hover color */
}

.navbar-admin-wrapper li button {
  font-family: "Eastlane Medium", "Montserrat", sans-serif; 
}

.navbar-admin-wrapper li button:hover {
  color: var(--highlight-color)!important; 
  background: none;
}

.header-content {
  display: flex;
  justify-content: space-between; /* Push items apart */
  align-items: center; /* Align vertically */
  width: 100%;
}

.create-user-btn {
  border-radius: 2px;
  border: solid 1px var(--secondary-text-color);
  color: var(--secondary-text-color);
  width: 200px;
  background-color: var(--background-color);
}

.create-user-btn:hover {
  border: solid 1px var(--text-color);
  color: var(--text-color);
  background-color: var(--background-color);
}
`, "",{"version":3,"sources":["webpack://./src/Admin.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;EACb,yCAAyC,EAAE,oBAAoB;EAC/D,wBAAwB,EAAE,eAAe;EACzC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,6CAA6C;EAC7C,kBAAkB;EAClB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,mDAAmD;EACnD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,4BAA4B;EACjD,kBAAkB,EAAE,oCAAoC;EACxD,2BAA2B,EAAE,6BAA6B;AAC5D;;AAEA;EACE,wCAAwC,EAAE,8BAA8B;AAC1E;;AAEA;EACE,aAAa,EAAE,wCAAwC;EACvD,SAAO;EACP,gBAAgB;EAChB,+CAA+C,EAAE,kBAAkB;EACnE,YAAY,EAAE,oCAAoC;EAClD,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,4BAA4B;AACnD;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB,EAAE,mBAAmB;AACxC;;AAEA;EACE,eAAe,EAAE,gCAAgC;EACjD,kCAAkC,EAAE,yBAAyB;AAC/D;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kCAAkC,EAAE,2BAA2B;EAC/D,iBAAiB;AACnB;;AAEA;EACE,wBAAwB,EAAE,0BAA0B;AACtD;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,6CAA6C;EAC7C,kBAAkB;AACpB;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,uCAAuC,EAAE,uBAAuB;AAClE;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B,EAAE,qBAAqB;EACrD,mBAAmB,EAAE,qBAAqB;EAC1C,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,6CAA6C;EAC7C,kCAAkC;EAClC,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;EACxB,yCAAyC;AAC3C","sourcesContent":["@import './variables.css';\n\n.admin-wrapper {\n  display: flex;\n  box-sizing: border-box;\n  padding-top: 64px;\n  height: 100vh;\n  background-color: var(--background-color); /* Dark background */\n  color: var(--text-color); /* Text color */\n  font-family: \"Montserrat\", sans-serif; \n}\n\n.admin-main {\n  padding: 20px;\n  width: 90%;\n  margin: 0 auto;\n}\n\n.admin-header {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 20px;\n  font-family: 'Eastlane Medium', sans-serif;\n}\n\n.user-count {\n  margin-top: 10px;\n  font-size: 16px;\n  color: var(--secondary-text-color);\n  font-weight: 600;\n}\n\n.search-input {\n  padding: 10px;\n  border: 1px solid var(--secondary-text-color);\n  border-radius: 4px;\n  margin-top: 10px;\n  background: var(--secondary-background-color);\n}\n\n.user-table {\n  background-color: var(--secondary-background-color);\n  border-radius: 2px;\n  overflow: hidden;\n}\n\n.table-header {\n  display: flex;\n  font-weight: bold;\n  padding-left: 10px;\n}\n\n.table-header .table-cell {\n  text-align: left;\n  font-weight: 800;\n  /* padding-left: 25px; */\n}\n\n.table-row {\n  display: flex;\n  align-items: center; /* Center items vertically */\n  padding: 10px 15px; /* Set consistent padding for rows */\n  transition: background 0.3s; /* Smooth background change */\n}\n\n.table-row:hover {\n  background-color: var(--secondary-color); /* Change color on row hover */\n}\n\n.table-cell {\n  padding: 10px; /* Ensure consistent padding for cells */\n  flex: 1;\n  text-align: left;\n  border-bottom: 1px solid var(--secondary-color); /* Row separator */\n  height: 50px; /* Set a fixed height if necessary */\n  align-content: center;\n  font-weight: 500;\n}\n\n.user-info {\n  display: flex;\n  align-items: center; /* Center items vertically */\n}\n\n.user-picture {\n  margin-right: 10px;\n  font-size: 20px;\n}\n\n.user-name {\n  font-weight: bold; /* Make name bold */\n}\n\n.user-email {\n  font-size: 12px; /* Smaller font size for email */\n  color: var(--secondary-text-color); /* Grey color for email */\n}\n\n.actions {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.action-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--secondary-text-color); /* Color for action icons */\n  margin-left: 10px;\n}\n\n.action-button:hover {\n  color: var(--text-color); /* Change color on hover */\n}\n\n.nav-item {\n  padding: 15px;\n  font-size: 1.1rem;\n  cursor: pointer;\n  transition: background-color 0.3s, color 0.3s;\n  border-radius: 8px;\n}\n\n.navbar-admin-wrapper {\n  font-family: \"Eastlane Medium\", \"Montserrat\", sans-serif; \n}\n\n.navbar-admin-wrapper li a {\n  font-family: \"Eastlane Medium\", \"Montserrat\", sans-serif; \n}\n\n.navbar-admin-wrapper li a:hover {\n  color: var(--highlight-color)!important; /* Adjust hover color */\n}\n\n.navbar-admin-wrapper li button {\n  font-family: \"Eastlane Medium\", \"Montserrat\", sans-serif; \n}\n\n.navbar-admin-wrapper li button:hover {\n  color: var(--highlight-color)!important; \n  background: none;\n}\n\n.header-content {\n  display: flex;\n  justify-content: space-between; /* Push items apart */\n  align-items: center; /* Align vertically */\n  width: 100%;\n}\n\n.create-user-btn {\n  border-radius: 2px;\n  border: solid 1px var(--secondary-text-color);\n  color: var(--secondary-text-color);\n  width: 200px;\n  background-color: var(--background-color);\n}\n\n.create-user-btn:hover {\n  border: solid 1px var(--text-color);\n  color: var(--text-color);\n  background-color: var(--background-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
